module.exports = __webpack_public_path__ + "8842bf0946a9d3e5287d8365a1b68602.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/assets/images/ProductionShiftReportSection7.png
// module id = 318
// module chunks = 0